import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email(),
  password: z
    .string()
    .min(8, { message: 'Password must be at least 8 characters long' })
    .max(20, { message: 'Password must be less than 20 characters long' })
});

export const registerSchema = z
  .object({
    role: z.enum(['customer', 'vendor']),
    fullName: z.string().min(1, { message: 'Full name is required' }),
    email: z.string().email(),
    password: z
      .string()
      .min(8, { message: 'Password must be at least 8 characters long' })
      .max(20, { message: 'Password must be less than 20 characters long' }),
    confirmPassword: z.string(),
    termsService: z.boolean().refine(val => val === true, {
      message: 'You must accept the terms and conditions'
    })
  })

  .refine(data => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword']
  });

export const vendorSchema = z.object({
  fullName: z.string().min(1, 'Full Name is required'),
  email: z.string().email('Invalid email address'),
  phone: z.string().min(5, 'Phone number is too short'),
  address: z.object({
    street: z.string().min(1, 'Street is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(1, 'State is required'),
    country: z.string().min(1, 'Country is required'),
    postalCode: z.string().min(1, 'Postal Code is required'),
    phone: z.string().optional()
  })
});

export const customerSchema = z.object({
  fullName: z.string().min(1, 'Full Name is required'),
  email: z.string().email('Invalid email address'),
  dob: z.preprocess(val => {
    if (typeof val === 'string' && val.trim() !== '') {
      return new Date(val);
    }
    return null;
  }, z.date().nullable().optional()),
  gender: z.string().optional(),
  phone: z.string().optional(),
  alternatePhone: z.string().optional(),
  shippingAddress: z.object({
    street: z.string().min(1, 'Street is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(1, 'State is required'),
    country: z.string().min(1, 'Country is required'),
    postalCode: z.string().min(1, 'Postal Code is required'),
    phone: z.string().optional()
  }),
  billingAddress: z.object({
    street: z.string().min(1, 'Street is required'),
    city: z.string().min(1, 'City is required'),
    state: z.string().min(1, 'State is required'),
    country: z.string().min(1, 'Country is required'),
    postalCode: z.string().min(1, 'Postal Code is required'),
    phone: z.string().optional()
  })
});

export type CustomerFormData = z.infer<typeof customerSchema>;
export type VendorFormData = z.infer<typeof vendorSchema>;
export type LoginSchema = z.infer<typeof loginSchema>;
export type RegisterSchema = z.infer<typeof registerSchema>;
